import React from "react";
import history from "../../../utils/history";
import Button from '@material-ui/core/Button';


export default [
    {
        selector: '[data-tut="reactour__state"]',
        content: () => {
            const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
            if (nextArrow) nextArrow.onclick = () => history.push('/Dashboard/History');
            return (
                <div className="intro-card">
                    <h4>Intro</h4>
                    <br />
                Now that you know how PhishCloud helps you identify and prevent phishing, let’s take a look at your personal portal.
                    <br />
                    <br />
                First, let’s explore your history page.  PhishCloud takes *your* privacy extremely seriously!
                The information on this page only you can see.  No admin or developers have access to your browsing history.
                The only time we’ll share details with anyone except you is when we detect a malicious event has occurred and
                we’ll generate an alert for the Security team to notify and help you.

                </div>
            )
        },
    },
    {
        selector: '.selector-bar-metrics',
        position: [20, 1200],
        action: () => history.push('/Dashboard/History'),
        content: () => {
            const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
            if (nextArrow) nextArrow.onclick = () => console.log('.')
            return (
                <div className="intro-card">
                    <h4>User History</h4>
                    <br />
                At the top of the page you’ll see multiple items about your activity,
                including which computer you were on when an event happened.
                Each person can use PhishCloud on up to 5 devices,
                so feel free to install us on other devices for complete and private protection.

                </div>
            )
        },
    },
    {
        selector: '.selector-link-history-table',
        content: () => (
            <div className="intro-card">
                <h4>User History</h4>
                <br />
                The last 250 links that you’ve seen will appear here.
                You’ll be surprised at how many links you see in a day!

            </div>
        ),
    },
    {
        selector: '.selector-news',
        position: 'left',
        content: () => (
            <div className="intro-card">
                <h4>User History</h4>
                <br />
                We will keep you up to date with some relevant news in the security world - check in often to see what’s happening.

            </div>
        ),
    },
    {
        selector: '.selector-training',
        content: () => {
            const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
            if (nextArrow) nextArrow.onclick = () => history.push('/Dashboard/Configuration');

            return (
                <div className="intro-card">
                    <h4>User History</h4>
                    <br />
            Your training dashboard will help you stay current on training and we will suggest videos for you based on the types of malicious links you find on the internet.

                </div>
            )
        },
    },
    {
        selector: '.selector-website-list',
        action: () => history.push('/Dashboard/Configuration'),
        content: () => {
            const nextArrow = document.querySelector('[data-tour-elem="right-arrow"]');
            if (nextArrow) nextArrow.onclick = () => console.log(".")
            const previousArrow = document.querySelector('[data-tour-elem="left-arrow"]');
            if (previousArrow) previousArrow.onclick = () => history.push('/Dashboard/History');
            return (
                <div className="intro-card">
                    <h4>User Configs</h4>
                    <br />
            In the User Configuration section, you can see which sites we will auto-scan for you.
            These are the sites where you will see the red/yellow/green bubbles as you navigate with your mouse.  Any other site, if you have a question about a link, just right-click and check the link.

                </div>
            )
        },
    },
    {
        selector: '.selector-darkMode-toggle',

        content: () => {
            const previousArrow = document.querySelector('[data-tour-elem="left-arrow"]');
            if (previousArrow) previousArrow.onclick = () => console.log(".")

            const element = document.getElementById('display-switches-rectangle');
            const elementRect = element.getBoundingClientRect();
            const absoluteElementTop = elementRect.top + window.pageYOffset;
            const middle = absoluteElementTop - (window.innerHeight / 2);
            window.scrollTo(0, middle);


            return (
                <div className="intro-card">
                    <h4>User Configs</h4>
                    <br />
            You can also go into dark mode!

                </div>
            )
        },
    },
    {
        position: 'center',
        selector: '[data-tut="reactour__state"]',
        content: () => (
            <div className="intro-card">
                <h4>Feedback</h4>
                <br />
            If you have any questions or suggestions about sites that you’d like PhishCloud to automatically scan,
            let us know at <a href="mailto:info@phishcloud.com">info@phishcloud.com</a>.

            </div>
        ),
    },

]